import { render } from "./OcrExcelPanel.vue?vue&type=template&id=3dc5b29f"
import script from "./OcrExcelPanel.vue?vue&type=script&lang=js"
export * from "./OcrExcelPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__